.footer-type-5 {
  .me-container {
    display: flex;
    flex-direction: column;
    gap: var(--spacing-4xl);

    @include desktop-lg {
      gap: var(--spacing-5xl);
    }
  }

  &__form {
    .me-heading--6 {
      margin-bottom: 0;
      font-size: 18px;
    }
  }

  .me-socials {
    display: flex;
    align-items: center;

    &__item {
      display: inline-block;
      height: 24px;
    }
  }

  &__secondary {
    @include desktop {
      margin-bottom: 16px;
    }
  }
}

.footer-type-5__legal-links {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-lg);

  @include desktop {
    flex-direction: row;
    gap: var(--spacing-xl);
  }

  a {
    font-size: map-get($font-sizes, sm);
    font-weight: map-get($font-weights, normal);
    color: var(--color-neutral-black);
  }
}

.footer-type-5__legal-copyright {
  @include below-desktop {
    order: 1;
    width: 100%;
  }
}

.footer-type-5__menus {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-3xl);

  @include above($breakpoint-desktop-md) {
    flex-direction: row;
  }

  @include above($breakpoint-desktop-md) {
    footer-menu-type-1 {
      flex: 0 0 calc(20% - 34px);
    }
  }
}

.footer-type-5__socials-language-switcher {
  display: flex;
  flex-direction: row-reverse;
  justify-content: space-between;
  order: 1;
  width: 100%;

  @include above($breakpoint-desktop-md) {
    flex-direction: row;
    justify-content: flex-end;
    gap: var(--spacing-xl);
    text-align: right;
    width: auto;
  }
}

.footer-type-5__social-links {
  display: flex;
  align-items: center;

  @include below-desktop {
    order: 2;
    width: 100%;
  }
}

.footer-type-5__divider {
  @include size(100%, 1px);

  background-color: var(--color-neutral-black);
}
